export default __webpack_public_path__ + "static/media/hk_flash_pay_banner.acd85de5.png";